import $ from 'jquery';

import Class from '../legacy-class';

export default Class({
    init: function () {
        this._radius = 40;

        this._displayed_progress = 0.0;

        this._svg = $(
            '<svg class="ui-progress-circle" viewBox="0 0 100 100">' +
                '<circle cx="50" cy="50" r="40" style="fill: none; stroke: rgba(240, 240, 240, 0.5); stroke-width: 20px"/>' +
                '<path style="fill: none; stroke: #ffffff; stroke-width: 20px"/>' +
                '</svg>'
        );
    },

    element: function () {
        return this._svg;
    },

    _arc: function (angle, radius, multiplier) {
        var x = multiplier * Math.sin(angle) * radius;
        var y = multiplier * (1 - Math.cos(angle)) * radius;
        return (
            'a ' + radius + ' ' + radius + ' 0 0 1 ' + x.toFixed(5) + ' ' + y.toFixed(5)
        );
    },

    _pathForPercent: function (percent, radius) {
        percent = Math.max(0, Math.min(1, percent));

        var angle1 = Math.PI * 2 * Math.min(percent, 0.5);
        var angle2 = Math.PI * 2 * (percent - 0.5);

        var path = this._arc(angle1, radius, 1);

        if (angle2 > 0) path += ' ' + this._arc(angle2, radius, -1);

        return path;
    },

    _update: function () {
        this._svg
            .find('path')
            .attr(
                'd',
                'M 50 10 ' +
                    this._pathForPercent(this._displayed_progress % 1, this._radius)
            );
    },
}).implement(
    Class.Properties({
        progress: {
            value: 0.0,

            set: function (value, animated) {
                this._progress = value;

                // if ((animated != false) && value > this._displayed_progress)
                // {
                //     $(this).stop().animate({ _displayed_progress: value }, {
                //         duration: 'slow',
                //         step: this._update
                //     })
                // }
                // else
                // {
                //     $(this).stop()
                //     this._displayed_progress = value
                //     this._update()
                // }

                if (animated != false) {
                    this._displayed_progress %= 1;

                    var target = value;
                    if (target < this._displayed_progress) target += 1;

                    $(this)
                        .stop()
                        .animate(
                            {_displayed_progress: target},
                            {
                                duration: 'fast',
                                step: this._update,
                                complete: function () {
                                    this._displayed_progress %= 1;
                                }.bind(this),
                            }
                        );
                } else {
                    $(this).stop();
                    this._displayed_progress = value;
                    this._update();
                }
            },
        },
    })
);
